export default "__VITE_ASSET__Cpj8GDRd__"